import { ActionTree } from 'vuex'
import { LocalStorageState } from './state'
import {
  LocalStorageMutationTypes,
} from './mutations'
import { RootState } from '../../state'

export enum LocalStorageActionTypes {
  GetLocalStorage = '[LocalStorage Action] Get Local Storage',
}

export const actions: ActionTree<LocalStorageState, RootState> = {

  [LocalStorageActionTypes.GetLocalStorage](context) {
    const payload = localStorage
    context.commit(LocalStorageMutationTypes.GetAllSuccess, payload)
    return payload
  },

}
